module.exports = __webpack_public_path__ + "static/img/test2.dbbe693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/test2.png
// module id = c6Fj
// module chunks = 1